<template>
  <!-- 应用根组件 -->
  <router-view />
</template>

<script setup lang="ts">
// 应用根组件
// 布局由路由配置决定：
// - 管理页面使用 AdminLayout（侧边栏 + 顶部栏 + 内容区）
// - Designer/Font 页面使用全屏独立布局
</script>

<style lang="scss" scoped>
// 根组件无需额外样式，布局由子组件控制
</style>